module.exports = __webpack_public_path__ + "static/media/NIU_FL.4121ad8d.png";